import { prefix } from "./utils";

export const AREA_PIECES = /*#__PURE__*/ prefix("area-pieces");
export const AREA_PIECE = /*#__PURE__*/ prefix("area-piece");
export const AVOID = /*#__PURE__*/ prefix("avoid");
